import angular from 'angular';
import APIV5 from '~/models/api';
import Form from '~/scripts/services/model/form';
import WorkflowAffect from '~/scripts/services/model/workflow-affect';

/* globals Knitiv */

export default class WorkflowController {
	#$injector;

	#$location;

	#$rootScope;

	#$routeParams;

	#$scope;

	#$timeout;

	#$window;

	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {any} $scope
	 */
	constructor($injector, $rootScope, $scope) {
		this.#$injector = $injector;
		this.#$location = $injector.get('$location');
		this.#$rootScope = $rootScope;
		this.#$routeParams = $injector.get('$routeParams');
		this.#$scope = $scope;
		this.#$timeout = $injector.get('$timeout');
		this.#$window = $injector.get('$window');
		this.FormService = $injector.get('FormService');
		this.User = $injector.get('User');

		this.actionKid = undefined;

		/** @type {import('~/scripts/services/model/workflow-affect').default | undefined} */
		this.affect = undefined;

		this.affectKid = undefined;
		this.disabled = false;
		this.file = undefined;
		this.form = undefined;

		/** @type {import('~/components/wf/wf-form-actions/wf-form-actions.controller').WfFormActionsControllerOptions} */
		this.formActionsOptions = {};

		this.kds = this.#$rootScope.kds;

		this.loading = false;
		this.options = {
			readOnly: true,
			rg:       true,
		};
		this.resizing = false;
		this.pendingWf = false;
		this.profil = undefined;

		this.width = this.#$window.innerWidth;

		angular.element(this.#$window).bind('resize', () => {
			this.width = this.#$window.innerWidth;
			this.initWidth();
			this.#$scope.$digest();
		});

		this.#$scope.$on('$viewContentLoaded', () => this.init());

		// functionnality for popin workflow reload
		// $rootScope.$on('wfReload', () => {
		// 	this.init();
		// });

		let search;
		try {
			search = JSON.parse(this.#$location.search().params);
		}
		catch {
			search = undefined;
		}

		this.formActionsOptions.from = {
			path: this.#$location.search().from,
			search,
		};

		// this.init();
		this.initWidth();
	}

	cancel() {
		if (this.formActionsOptions.from?.path) {
			this.#$location
				.path(this.formActionsOptions.from.path)
				.search(this.formActionsOptions.from.search);
		}
		else {
			this.#$location.url('/');
		}
	}

	// eslint-disable-next-line class-methods-use-this
	/**
	 * @param {Form} form
	 * @returns {string | undefined} form name
	 */
	getName(form) {
		let name = form.isa?.objname;
		if (form.name) {
			name += ` : ${form.name}`;
		}
		return name;
	}

	async init() {
		this.affectKid = this.#$routeParams.affectKid;

		try {
			const wfAffect = await APIV5.instance.wfAffectInfo({ wfaffect_kid: this.affectKid }, { id: 'workflow.init' });
			this.affect = new WorkflowAffect(this.#$injector, wfAffect);
			this.actionKid = this.affect.action.kid;
			this.disabled = this.affect.status.kid !== 'K_NODE;WFS_INPROGRESS';
			const documentKid = this.affect.document.kid;

			this.form = await this.FormService.load(documentKid, this.options);
			this.form.id = `KF${this.form.kid.split(';')[1]}`;
			this.selectedForm = this.form.kid;
			this.form.droit = this.form.submission.kdroit;
			this.form.tab = this.form.isfile ? 'file' : 'form';

			if (!this.form.isTerminal) {
				this.name = this.getName(this.form);
			}

			this.#$timeout(() => {
				this.tab = this.form.tab;
				if (this.tab === 'file') {
					this.#$timeout(() => {
						this.refreshTabFile();
						this.#$scope.$apply();
					});
				}

				this.#$scope.$apply();
			}, 100);
		}
		catch (error) {
			console.error(error);
			this.loading = false;
			this.affect = undefined;
		}

		this.#$scope.$on('angular-resizable.resizing', () => {
			if (!this.resizing) {
				this.resizing = true;
				this.#$scope.$apply();
			}
		});

		this.#$scope.$on('angular-resizable.resizeEnd', () => {
			if (this.resizing) {
				this.#$timeout(() => {
					this.resizing = false;
				}, 50);
			}
		});
	}

	initWidth() {
		this.leftW = (this.width / 3) - 10;
		this.rightW = this.leftW;
		this.centerW = this.rightW;
		this.leftS = true;
		this.rightS = true;
		this.centerS = true;
	}

	refreshTabFile() {
		this.tab = 'file';
		if (this.form.viewer_engine === 'pdf') {
			this.#$scope.$broadcast('Form.change-tab');
		}
	}

	refreshWorkflows() {
		this.#$scope.$broadcast('wf-list:refresh');
	}

	resizeLeft() {
		this.centerW = 0;
		this.leftW = this.width - 30;
		this.rightW = 0;
		this.rightS = false;
		this.centerS = false;
		this.leftS = true;
	}

	resizeCenter() {
		this.leftW = 0;
		this.rightW = 0;
		this.centerW = this.width - 30;
		this.centerS = true;
		this.leftS = false;
		this.rightS = false;
	}

	resizeRight() {
		this.leftW = 0;
		this.rightW = this.width - 30;
		this.centerW = 0;
		this.rightS = true;
		this.leftS = false;
		this.centerS = false;
	}

	restore() {
		this.leftW = (this.width / 3) - 10;
		this.rightW = (this.width / 3) - 10;
		this.centerW = (this.width / 3) - 10;
		this.rightS = true;
		this.leftS = true;
		this.centerS = true;
	}
}
